export default __webpack_public_path__ + "static/media/auction-img.e7b50f38.png";